import bookMetadata from './books.json';
import storyIndexes from './generated-story-indexes';

/** Lightweight catalog: book cards and chapter listings never import story prose. */
export const books = bookMetadata.map(book => ({
  ...book,
  stories: storyIndexes[book.slug] || [],
}));

/**
 * Fetch one story's own code-split JSON module on demand.
 * Webpack creates async chunks, rather than loading all 36 stories upfront.
 */
export async function loadKathaStory(bookSlug, storySlug) {
  const found = books.find(book => book.slug === bookSlug);
  if (!found || !found.stories.some(story => story.slug === storySlug)) {
    throw new Error('कथा उपलब्ध नहीं है');
  }
  const module = await import(
    /* webpackChunkName: "katha-story-[request]" */
    `./stories/${bookSlug}/${storySlug}.json`
  );
  return module.default || module;
}
